import { Controller } from "@hotwired/stimulus";

// import './style.css';
import { Point } from 'ol/geom.js';
import { Feature, Map, View } from 'ol/index.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { useGeographic } from 'ol/proj.js';
import { Vector as VectorSource } from 'ol/source.js';
import StadiaMaps from 'ol/source/StadiaMaps.js';

import { log } from "../../../javascript/utils/logger";
import { markerStyle } from "../../../javascript/utils/map_marker";
export default class extends Controller {
  static targets = ["map", "latitudeField", "longitudeField"]
  static values = {
    center: Object,
    reference: Object
  }


  connect() {
    log("location picker connect")
    useGeographic();

    if (this.isPreview) {
      log("skip rendering for preview")
    } else {
      const config = this.buildConfig()
      this.initializeMap(config)
    }
  }

  disconnect() {
    log("location picker disconnect")
    this.map.setTarget(null)
    this.map.getLayers().forEach((layer) => this.map.removeLayer(layer))
    this.map = null
  }

  buildConfig() {
    const mapElement = this.mapTarget
    var center = this.centerValue
    var previouslySet = center.lat && center.lng

    if (!previouslySet) {
      center = { lat: 40.841969747104116, lng: -97.42252733955526 }
    }

    var zoom = previouslySet ? 14 : 3

    const mapStyle = this.isDarkMode ? 'alidade_smooth_dark' : 'osm_bright'

    return { mapElement, center, zoom, previouslySet, mapStyle }
  }

  async initializeMap({ mapElement, center, zoom, previouslySet, mapStyle }) {
    this.source = new VectorSource({
      features: [],
    })

    this.view = new View({
      center: [center.lng, center.lat],
      zoom,
      minZoom: 4,
      enableRotation: false
    })

    log("mounting map", mapElement, {
      center, zoom
    })

    const map = new Map({
      target: mapElement,
      layers: [
        new TileLayer({
          source: new StadiaMaps({
            layer: mapStyle, retina: true,
          }),
        }),
        new VectorLayer({
          source: this.source,
          style: (feature, _) => {
            if (feature.get("type") == "SELECTED") {
              return markerStyle({ color: "red", scale: 1 });
            }
            else {
              return markerStyle({ color: "grey", scale: 1 });
            }
          }
        })
      ],
      view: new View({
        center: [center.lng, center.lat],
        zoom,
        minZoom: 4,
        enableRotation: false
      })
    })
    this.map = map


    if (this.hasReferenceValue) {
      this.addReferenceMarker(this.referenceValue.lat, this.referenceValue.lng)
    }

    if (previouslySet) {
      this.addMarker(center.lat, center.lng)
    }

    map.on('singleclick', (event) => {
      const coordinate = event.coordinate
      log('click', coordinate)
      this.addMarker(coordinate[1], coordinate[0])
    })
  }

  addMarker(lat, lng) {
    const feature = new Feature({
      geometry: new Point([lng, lat]),
      type: "SELECTED"
    })

    this.source.removeFeature(this.currentFeature)
    this.source.addFeature(feature)
    this.currentFeature = feature
    this.latitudeFieldTarget.value = lat
    this.longitudeFieldTarget.value = lng
  }

  addReferenceMarker(lat, lng) {
    const feature = new Feature({
      geometry: new Point([lng, lat]),
      type: "REFERENCE",
      style: markerStyle({ color: "grey", scale: 1 }),
    })

    this.source.addFeature(feature)
  }

  get isPreview() {
    return document.documentElement.hasAttribute('data-turbolinks-preview')
  }

  get isDarkMode() {
    return document.querySelector('html').classList.contains("dark")
  }
}
